import React, { useState } from 'react';
import { Grid, Typography, Box, Button, Card, CardContent, CardMedia, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/system';
import allmix from '../images/allmix.png';
import reactall from '../images/react sj.png';
import image from '../images/second screen.png';

const StyledContainer = styled('div')({
  perspective: '1000px',
});

const StyledImage = styled('img')({
  width: '100%',
  height: 'auto',
  transition: 'transform 0.1s ease',
  '&:hover': {
    transform: 'rotateY(10deg) rotateX(10deg)',
  },
});

const Increase = () => {
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmallScreen = useMediaQuery('(min-width:1024px) and (max-width:1440px)');
  const isLargeDesktop = useMediaQuery('(min-width:1440px)');

  const handleClick = (index) => {
    setValue(index);
  };

  const getFontSize = (mobileSize, desktopSize, smallScreenSize, largeDesktopSize) => {
    if (isMobile) return mobileSize;
    if (isSmallScreen) return smallScreenSize;
    if (isLargeDesktop) return largeDesktopSize;
    return desktopSize;
  };

  const getSize = (mobileSize, desktopSize, smallScreenSize, largeDesktopSize) => {
    if (isMobile) return mobileSize;
    if (isSmallScreen) return smallScreenSize;
    if (isLargeDesktop) return largeDesktopSize;
    return desktopSize;
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} sx={{ marginTop: 3, display: 'flex', justifyContent: 'center' }}>
          <StyledContainer sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <StyledImage src={image} alt="photo" />
          </StyledContainer>
        </Grid>
        <Grid item xs={12} md={6} sx={{ marginTop: 1 }}>
          <Typography
            variant="h6"
            sx={{
              color: '#684df4',
              marginTop: 6,
              marginLeft: { md: 5, xs: 0 },
              fontWeight: 700,
              fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
              fontSize: getFontSize(15, 25, 18, 35),
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            About SN Info Systems
          </Typography>
          <Typography
            variant="h4"
            sx={{
              marginTop: 2,
              marginLeft: { md: 5, xs: 0 },
              fontWeight: 700,
              width: { xs: '100%' },
              fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
              fontSize: getFontSize(26, 40, 34, 50),
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            Elevating Your Business <br />
            with <span style={{ color: '#684df4' }}> Technology</span>
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              color: '#666',
              marginTop: 2,
              marginLeft: { md: 5, xs: 0 },
              textAlign: { xs: 'center', md: 'left' },
              fontSize: getFontSize(15, 16, 18, 20),
              width: { xs: '95%' },
              fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
            }}
          >
            At SN Info Systems, we're dedicated to leveraging cutting-edge technology to elevate your business and drive growth and innovation.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: 4 }}>
            <Grid container spacing={2}>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={() => handleClick(0)}
                  sx={{
                    marginLeft: '40px',
                    backgroundColor: '#684df4',
                    color: '#fff',
                    borderRadius: 0,
                    fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                    fontSize: getFontSize('13px', '21px', '16px', '24px'),
                    '&:hover': {
                      backgroundColor: '#684df4',
                    },
                  }}
                >
                  OUR SERVICES
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={() => handleClick(1)}
                  sx={{
                    backgroundColor: '#141d38',
                    color: '#fff',
                    borderRadius: 0,
                    fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                    fontSize: getFontSize('13px', '21px', '16px', '24px'),
                    '&:hover': {
                      backgroundColor: '#141d38',
                    },
                  }}
                >
                  TECHNOLOGY INDEX
                </Button>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} display={value === 0 ? 'block' : 'none'}>
                <Card
                  sx={{
                    margin: '16px',
                    padding: '32px',
                    width: getSize('74%', '70%', '80%', '90%'),
                    marginLeft: { md: 5 },
                    marginTop: getSize('16px', '24px', '20px', '32px'),
                  }}
                >
                  <Grid container spacing={2} alignItems="center" direction={isMobile ? 'column' : 'row'}>
                    <Grid item xs={12} sm={4} display="flex" justifyContent="center">
                      <CardMedia
                        component="img"
                        image={allmix}
                        alt="Award"
                        sx={{ width: '200px', height: '200px', borderRadius: '8px', marginLeft: { md: 3 } }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <CardContent
                        sx={{
                          textAlign: "left",
                          justifyContent: 'center',
                          px:3
                        }}
                      >
                        <Typography
                          variant="h5"
                          component="div"
                          gutterBottom
                          sx={{
                            color: '#0d1a3f',
                            fontWeight: 600,
                            fontSize: getFontSize('1.5rem', '1.5rem', '1.5rem', '2rem'),
                            fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                          }}
                        >
                          We Provide Expert Solutions to Success
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          component="p"
                          sx={{ marginBottom: '16px', fontSize: getFontSize('1rem', '1rem', '1rem', '1.2rem'), fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}
                        >
                          At SN Info Systems, we offer tailored services to help your business thrive in the digital age.
                        </Typography>
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: '#7f3ff2',
                            color: '#fff',
                            fontSize: getFontSize('1rem', '1rem', '1rem', '1.2rem'),
                            padding: getSize('10px 20px', '10px 20px', '12px 20px', '15px 25px'),
                            fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                          }}
                        >
                          ABOUT MORE
                        </Button>
                      </CardContent>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item xs={12} display={value === 1 ? 'block' : 'none'}>
              <Card
                  sx={{
                    margin: '16px',
                    padding: '32px',
                    width: getSize('74%', '70%', '80%', '90%'),
                    marginLeft: { md: 5 },
                    marginTop: getSize('16px', '24px', '20px', '32px'),
                  }}
                
                >
                  <Grid container spacing={2} alignItems="center" direction={isMobile ? 'column' : 'row'}>
                    <Grid item xs={12} sm={4} display="flex" justifyContent="center">
                      <CardMedia
                        component="img"
                        image={reactall}
                        alt="Award"
                        sx={{ width: '200px', height: '200px', borderRadius: '8px', marginLeft: { md: 3 } }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <CardContent
                        sx={{
                          textAlign: isMobile ? 'center' : 'left',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography
                          variant="h5"
                          component="div"
                          gutterBottom
                          sx={{
                            color: '#0d1a3f',
                            fontWeight: 600,
                            fontSize: getFontSize('1.5rem', '1.5rem', '1.5rem', '2rem'),
                            fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                          }}
                        >
                          Implementing Cutting-Edge Technologies
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          component="p"
                          sx={{ marginBottom: '16px', fontSize: getFontSize('1rem', '1rem', '1rem', '1.2rem'),fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}
                        >
                          Our team stays ahead by utilizing ReactJS to create dynamic and responsive web applications.
                        </Typography>
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: '#7f3ff2',
                            color: '#fff',
                            fontSize: getFontSize('1rem', '1rem', '1rem', '1.2rem'),
                            padding: getSize('10px 20px', '10px 20px', '12px 20px', '15px 25px'),
                            fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                          }}
                        >
                          READ MORE
                        </Button>
                      </CardContent>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Increase;